export default __webpack_public_path__ + "static/media/plus-icon.b3120687.png";